import * as React from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { Translate } from '../../../../../shared/LanguageService';
import { ITemplate } from '../Types';
import * as Strings from './Strings';
import FormSelect from '../../../../../components/common/FormSelect';

interface IProps {
    onChange: (e: any) => void;
    templates: ITemplate[];
    template: number;
}

const TemplateSelect = (props: IProps) => {
    return (
        <FormGroup>
            <ControlLabel>
                {Translate('view-order/basic-order/modal/create-email/form/template/label')}
            </ControlLabel>
            <FormSelect
                name={Strings.templateSelectorName}
                value={props.template as any}
                onChange={props.onChange}
                defaultTranslateKey="view-order/basic-order/modal/create-email/form/template/placeholder"
            >
                {props.templates.map((t: ITemplate) => {
                    return (
                        <option key={t.id} value={t.id as any}>
                            {t.name}
                        </option>
                    );
                })}
            </FormSelect>
        </FormGroup>
    );
};

export default TemplateSelect;
